import { Currency } from '../../../../../common/models/enums/currency.enum';
import { MoneyAmount } from '../../../../../utils/money';
import { RestaurantCategoryPricingResponse } from '../../../../Restaurants/types';

export const getMinAndMaxFeeValues = (restaurantPricing: RestaurantCategoryPricingResponse[]) => {
  const values = restaurantPricing
    .map((categoryPricing) => categoryPricing.notReturnFee)
    .filter((value) => value > 0)
    .reduce(
      (acc, num) => ({
        min: num > 0 ? Math.min(acc.min, num) : acc.min,
        max: Math.max(acc.max, num),
      }),
      { min: Infinity, max: -Infinity },
    );
  if (values.min === values.max) {
    return [MoneyAmount.fromMinUnits(values.min).toMainUnits()];
  }
  return [
    MoneyAmount.fromMinUnits(values.min).toMainUnits(),
    MoneyAmount.fromMinUnits(values.max).toMainUnits(),
  ].filter((value) => value > 0 && value < Infinity);
};

export const getCardValue = (currency: Currency, amount: MoneyAmount) => {
  return (amount || MoneyAmount.fromMinUnits(0)).format(currency);
};
export const getBorrowedValue = (currency: Currency, notReturnFeeSum: MoneyAmount) => {
  return notReturnFeeSum.format(currency);
};
export const getUpgradeValue = (currency: Currency, amount: MoneyAmount, notReturnFeeSum: MoneyAmount) => {
  const amountValue = amount || MoneyAmount.fromMinUnits(0);
  const result = amountValue.subtract(notReturnFeeSum);
  return result.format(currency);
};
